import { render, staticRenderFns } from "./ConfirmDelete.vue?vue&type=template&id=16ca1840&scoped=true&"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDelete.vue?vue&type=style&index=0&id=16ca1840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ca1840",
  null
  
)

export default component.exports